import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';

const useStyles = makeStyles((theme: any) => ({
    fab: (props: any) => ({
        // margin: theme.spacing(1),
        zIndex: 1000,
        left: props.left ? `${props.left}` : 'auto',
        right: props.right ? `${props.right}` : 'auto',
        transform: props.position === 'absolute' ? 'translate(75%, -75%)' : 'translateY(0)',
        position: props.position ? props.position : 'static',
    }),
    container: {
        position: 'relative',
        overflow: 'visible',
    },
    paper: {
        position: 'relative',
    },

    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}));

interface IFabCreateProps {
    /** Callback invoked when fab is clicked */
    action: Function;

    /** CSS-positioning of Icon */
    position: 'static' | 'absolute' | 'relative';

    /** CSS right value */
    right?: string;

    /** CSS left value */
    left?: string;
}

/**
 * Interactive wrapper for Material UI Fab - good for creating "new" items
 */
const FabCreate = (props: IFabCreateProps) => {
    const classes = useStyles(props);
    return (
        <Fab
            data-cy="FabCreate"
            onClick={() => props.action()}
            color="primary"
            aria-label="Add"
            className={classes.fab}
        >
            <AddIcon />
        </Fab>
    );
};

export default FabCreate;
